import { apiBaseUrl, config } from './config';

/**
 * Fetches badge enrichments for a set of listing ids from the host app's own
 * API proxy (server/extensions/empavision-enrichments), which forwards to
 * empavision. Returns `{ [listingId]: Badge[] }`. Fails soft to {}.
 */
export const fetchEnrichments = async (listingIds, prices = {}) => {
  if (!config.isEnabled) {
    return {};
  }

  try {
    const response = await window.fetch(`${apiBaseUrl()}/api/empavision/enrich`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        integrationId: config.integrationId,
        listings: (listingIds || []).map(id => ({
          id,
          currentPrice: prices[id],
        })),
      }),
    });

    if (!response.ok) {
      return {};
    }

    const data = await response.json();
    return data && data.enrichments ? data.enrichments : {};
  } catch (error) {
    return {};
  }
};

/**
 * Records a listing view (fire-and-forget) via the host app's API proxy.
 */
export const recordView = async listingId => {
  if (!config.isEnabled) {
    return;
  }

  try {
    await window.fetch(`${apiBaseUrl()}/api/empavision/views`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        integrationId: config.integrationId,
        listingId,
      }),
    });
  } catch (error) {
    // fire-and-forget
  }
};
